import React from 'react';
import { Link } from 'react-router-dom';
import { buildAuthPath } from '../../utils/authRoutes';
import { AuthPageShell } from './AuthPageShell';
import './AuthFallbacks.css';

const GuestSessionFallback = ({ errorMessage, onRetry }) => {
  const isUserAgentMismatch =
    errorMessage === 'functions/permission-denied' ||
    errorMessage === 'permission-denied';

  return (
  <AuthPageShell>
    <h2 className="flashcode-auth-page__form-title">Could not start a guest session.</h2>
    <p className="flashcode-auth-page__form-subtitle">
      {isUserAgentMismatch
        ? 'We could not restore your previous guest session on this browser. Try again to start fresh, or sign in with an account.'
        : `Anonymous sign-in failed (${errorMessage}). Enable Anonymous sign-in in the Firebase console (Authentication → Sign-in method), or sign in with an account.`}
    </p>

    <div className="flashcode-auth-fallback-page__actions">
      <button type="button" className="flashcode-auth-page__btn-primary" onClick={onRetry}>
        Try again →
      </button>
      <Link
        to={buildAuthPath()}
        replace
        className="flashcode-auth-page__btn-primary flashcode-auth-page__btn-primary--secondary flashcode-auth-fallback-page__btn-link"
      >
        Sign in →
      </Link>
    </div>

    <p className="flashcode-auth-page__footer-toggle">
      New here?{' '}
      <Link to={buildAuthPath({ mode: 'signup' })} replace className="flashcode-auth-page__footer-link">
        Create account
      </Link>
    </p>
  </AuthPageShell>
  );
};

export default GuestSessionFallback;
